import React from 'react';
import { StyleSheet, Text, View } from 'react-native';

import { CourseType } from '../api/models/Course';
import { fonts, scale } from '../Styles';
import { MNOHSCourseDetailButton } from './MNOHSCourseDetailButton';

type Props = {
  /** title of the thing */
  title?: string;
  /** invoked if user presses a course detail tile */
  userPressedCourseDetails: (courseType: CourseType) => void;
};

export const MNOHSCourseGrid: React.FC<Props> = ({
  title = 'Click to view course details',
  userPressedCourseDetails,
}) => {
  return (
    <View style={styles.courseDetailsContainer}>
      <Text style={styles.courseDetailsHeader}>{title}</Text>
      <View style={styles.courseDetailsButtonWrapper}>
        <MNOHSCourseDetailButton courseType="LANGUAGE_ARTS" onPress={() => userPressedCourseDetails('LANGUAGE_ARTS')} />
        <MNOHSCourseDetailButton
          courseType="SOCIAL_STUDIES"
          onPress={() => userPressedCourseDetails('SOCIAL_STUDIES')}
        />
        <MNOHSCourseDetailButton courseType="SCIENCE" onPress={() => userPressedCourseDetails('SCIENCE')} />
        <MNOHSCourseDetailButton courseType="MATH" onPress={() => userPressedCourseDetails('MATH')} />
        <MNOHSCourseDetailButton courseType="HEALTH" onPress={() => userPressedCourseDetails('HEALTH')} />
        <MNOHSCourseDetailButton courseType="PE" onPress={() => userPressedCourseDetails('PE')} />
        <MNOHSCourseDetailButton courseType="ARTS" onPress={() => userPressedCourseDetails('ARTS')} />
        <MNOHSCourseDetailButton courseType="ELECTIVES" onPress={() => userPressedCourseDetails('ELECTIVES')} />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  courseDetailsContainer: {
    backgroundColor: '#fff',
    marginHorizontal: scale(-20),
    marginTop: scale(8),
    marginBottom: scale(52),
  },
  courseDetailsHeader: {
    ...fonts.header2,
    paddingHorizontal: scale(16),
    paddingTop: scale(16),
  },
  courseDetailsButtonWrapper: {
    padding: scale(12),
    flexDirection: 'row',
    flexWrap: 'wrap',
    width: '100%',
    flex: 1,
  },
});
